<mat-card>
  <mat-card-content>

    <!--  <div style="width:100%; background-color:#ffffff; text-align:center; border:1px solid green;">-->
    <div class="row" style="text-align: center; width:100%;">
      <img src="./assets/images/OK.png" width="50" height="50" />
    </div>

    <div class="row" style="text-align: left;">
      La richiesta di adesione è stata correttamente completata. Un email è stata inviata al suo indirizzo di posta
      elettronica con le istruzioni del pagamento e allegato l'avviso di pagamento.
      <br /> <strong>ATTENZIONE:</strong> Dopo aver effettuato il pagamento, è necessario comunicare i codici identificativi
      del pagamento cliccando su "Conferma il pagamento"
    </div>
    <br />
    <div class="row">
      <button mat-raised-button color="primary"
              (click)="btnRitornaAllaDashboard()"
              cdkFocusInitial>
     Ritorna alla Dashboard
      </button>
    </div>
      <!--  </div>-->
  </mat-card-content>
  </mat-card>
